import React from 'react';
import { useSpring, animated } from 'react-spring';

const AnimatedCircle = ({ cx, cy, r, ...props }) => {
  const animatedProps = useSpring({
    cx,
    cy,
    r,
  });
  return <animated.circle {...props} r={animatedProps.r} cx={animatedProps.cx} cy={animatedProps.cy} />;
};

export default AnimatedCircle;
